const COMPONENT_MESSAGE_TYPES = [
    'style-tiles',
    'color-selector',
    'icon-tiles',
    'review-method',
    'product-options',
    'reference-projects',
] as const;
type ComponentMessageType = (typeof COMPONENT_MESSAGE_TYPES)[number];

/**
 * Detect whether a raw content string is a structured component message.
 * Uses an allowlist of known component types to prevent false positives
 * (e.g. user typing arbitrary JSON).
 */
export function isComponentMessage(
    content: string
): { type: ComponentMessageType; data: unknown } | null {
    try {
        const parsed = JSON.parse(content);
        if (
            parsed &&
            typeof parsed === 'object' &&
            'type' in parsed &&
            'data' in parsed &&
            COMPONENT_MESSAGE_TYPES.includes(parsed.type)
        ) {
            return { type: parsed.type as ComponentMessageType, data: parsed.data };
        }
        return null;
    } catch {
        return null;
    }
}
